// Reusable horizontal tab strip used inside Modals (Merchant/Partner/Gateway
// edit forms). Mounts above the tab body — keeps the tabs DRY and consistent
// across the three pages that mount RateHistoryTab.
//
// Usage:
//   <ModalTabs tabs={[{id:"form",label:"Form"},{id:"rate",label:"Rate History"}]}
//              active={tab} onChange={setTab} testid="merchant-modal-tabs" />
export default function ModalTabs({ tabs = [], active, onChange, testid }) {
  return (
    <div className="flex items-center gap-1 border-b border-[var(--line)] mb-4 -mt-1" data-testid={testid}>
      {tabs.map((t) => {
        const isActive = active === t.id;
        return (
          <button
            type="button"
            key={t.id}
            data-testid={t.testid || `tab-${t.id}`}
            onClick={() => onChange(t.id)}
            className={`relative px-4 py-2.5 text-[12.5px] font-medium tracking-wide transition-colors ${
              isActive
                ? "text-[var(--ink)]"
                : "text-[var(--muted)] hover:text-[var(--ink)]"
            }`}
          >
            <span>{t.label}</span>
            {isActive && (
              <span className="absolute left-3 right-3 -bottom-px h-0.5 bg-[var(--accent)]" />
            )}
          </button>
        );
      })}
    </div>
  );
}
